import { DangerousIcon, MediumIcon, VettedIcon } from "../assets/icons/icons";

export const cautionStatus = (caution) => {
  if (+caution === 1) {
    return {
      icon: <VettedIcon />,
      title: "Shipping Cost Vetted",
      text: "We have verified the shipping cost for this offer.",
    };
  } else if (+caution === 2) {
    return {
      icon: <MediumIcon />,
      title: "Actual Shipping May Differ",
      text: "Caution: the estimated shipping cost for this offer may not be fully accurate.",
    };
  } else if (+caution === 3) {
    return {
      icon: <DangerousIcon />,
      title: "Shipping Cost Unknown",
      text: "We are unable to determine the shipping cost for this offer with any degree of confidence.",
    };
  }

  return {
    icon: '',
    title: '',
    text: ''
  }
};
